import 'react-confirm-alert/src/react-confirm-alert.css'
import { FaTrash } from 'react-icons/fa'

export const Confirm = (action, options = {}) => {
  const {
    title = 'Are you sure?',
    message = 'You want to delete this?',
    confirmLabel = 'Yes, Delete it!',
    confirmIcon = <FaTrash className='mb-1' />,
    confirmClass = 'btn btn-outline-danger bg-sm ml-1',
  } = options;

  return {
    customUI: ({ onClose }) => {
      return (
        <div className='px-5 py-3 shadow-lg text-center text-dark'>
          <h1>{title}</h1>
          <p>{message}</p>
          <div className='btn-group d-flex justify-content-between'>
            <button className='btn btn-outline-dark bg-sm' onClick={onClose}>
              No
            </button>
            <button
              className={confirmClass}
              onClick={() => {
                action()
                onClose()
              }}
            >
              {confirmIcon} {confirmLabel}
            </button>
          </div>
        </div>
      )
    },
  }
}
